export const defaultSummaryStyles = {
    root: {
        position: 'relative',
        minHeight: 45,
        margin: '-1px 0 0',
        '&$expanded': {
            minHeight: 45,
        },
        '@media (hover: hover)': {
            '&:hover': {
                backgroundColor: '#FFEAE7',
            },
            '&$expanded:hover': {
                backgroundColor: '#FFEAE7',
            },
        },
        '& h3': {
            font: '700 18px "InterDisplay", sans-serif',
            letterSpacing: '0.2px',
            margin: 'inherit',
            color: '#27272A',
            padding: '0 16px',
        },
        padding: '0 0px 0 0px',
        color: '#27272A'
    },
    content: {
        lineHeight: 0,
        margin: '5px 0',
        '&$expanded': {
            margin: '5px 0',
        },
    },
    expandIcon: {
        top: '23px',
        right: '12px',
        padding: 0,
        size: '8px',
        color: '#27272A',
        '& svg': {
            fontSize: '20px'
        }
    },
    expanded: {},
};

export const defaultPanelStyles = {
    root: {
        boxShadow: 'none',
        overflow: 'hidden',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
        borderBottomLeftRadius: '12px !important',
        borderBottomRightRadius: '12px !important',
        '&:before': {
            display: 'none',
        },
        '&:first-child': {
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
        },
        '&$expanded': {
            margin: 'auto',
        },
        '@media (hover: hover)': {
            '&:hover': {
                backgroundColor: '#FFEAE7',
            },
            '&$expanded:hover': {
                backgroundColor: '#FFEAE7',
            },
        },
    },
    expanded: {},
};

export const childPanelStyles = {
    root: {
        '&:first-child': {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
        '&:last-child': {
            borderBottomLeftRadius: '12px',
            borderBottomRightRadius: '12px',
        },
        '&:first-child$expanded': {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
        '&:last-child$expanded': {
            borderBottomLeftRadius: '12px',
            borderBottomRightRadius: '12px',
        },
        '&$expanded': {
            // borderRadius: 0,
        },
    },
    expanded: {},
};

export const defaultDetailsStyles = {
    root: {
        display: 'block',
        padding: '0',
        margin: '-1px 0 0',
        borderRadius: 0
    }
};

export const printableViewSummaryStyles = {
    root: {
        position: 'relative',
        minHeight: 45,
        margin: '-1px 0 0',
        '&$expanded': {
            minHeight: 45,
            backgroundColor: 'white',
        },
        '@media (hover: hover)': {
            '&:hover': {
                backgroundColor: '#FFEAE7',
            },
            '&$expanded:hover': {
                backgroundColor: '#FFEAE7',
            },
        },
        '& h3': {
            font: '600 20px/24px "InterDisplay", sans-serif',
            letterSpacing: '0.2px',
            margin: 0,
            padding: '0 16px',
        },
        padding: '0 0px 0 0px',
    },
    content: {
        lineHeight: 0,
        margin: '5px 0',
        '&$expanded': {
            margin: '5px 0',
        },
    },
    expandIcon: {
        visibility: 'hidden',
        top: '23px',
        right: 0,
        padding: 0,
        size: '8px',
        '& svg': {
            fontSize: '20px'
        }
    },
    expanded: {},
};

export const printableViewDetailsStyles = {
    root: {
        display: 'block',
        padding: '0',
        margin: '-1px 0 0',
        borderRadius: 0
    }
};
